export default "__VITE_ASSET__hYpDrWAu__"